import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  public enquiryPayLoad = {name: '', email: '', mobile_number: '', query_data: ''};

  @ViewChild('signInNgForm') signInNgForm: NgForm;
  enquiryForm: FormGroup;

  // enquiry api
  public enquiryResponseAwaited = false;
  public enquiryResponseReceived = false;
  public enquiryErrorMessage = '';
  public enquirySuccessful = false;
  public errorMessage = '';
  public queryType = '';

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private titleService: Title,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
          console.log(params); // { orderby: "price" }
          this.queryType = params.utm_campaign;
        }
      );

    this.enquiryForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(4)]],
      email: ['', [Validators.required, Validators.email]],
      mobile_number: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      query_data: ['', [Validators.required, Validators.minLength(10)]],
      type_of_query: [this.queryType]
    });

    this.titleService.setTitle('Things2do - Contact Us');
  }

  get f() {
    return this.enquiryForm.controls;
  }

  submitEnquiry(): void {

    Object.keys(this.enquiryForm.controls).forEach(field => { // {1}
      const control = this.enquiryForm.get(field);            // {2}
      control.markAsTouched({onlySelf: true});       // {3}
    });

    if (this.enquiryForm.valid) {

      this.enquiryForm.disable();

      const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      };

      this.enquiryResponseAwaited = true;

      this.http.post <any>(environment.domain + '/api/contact-us', this.enquiryForm.value, httpOptions).subscribe(
        data => {
          this.enquiryResponseReceived = true;
          if (data.type === 'success') {
            this.enquirySuccessful = true;
          } else {
            this.enquirySuccessful = true;
            this.enquiryErrorMessage = 'Some error occurred';
          }
        },
        error => {
          console.error('There was an error!', error);
          this.enquiryErrorMessage = 'Some error occurred.' + error;
        });
    }
  }
}
